import { useRouteError } from 'react-router-dom';
import { isApolloError } from '@apollo/client';

const isApolloNetworkError = (error: unknown): error is Error & { networkError: Error } => {
  return !!(error instanceof Error && isApolloError(error) && error.networkError);
};

const ErrorBoundary = () => {
  const error = useRouteError();

  let message: string | undefined;
  let stack: string | undefined;
  if (error instanceof Error) {
    message = error.message;
    stack = error.stack || '';
  }

  return (
    <div>
      <div className="l-title-wrap" />
      <div className="l-wrap-xs">
        <div className="l-box-message">
          <p className="m-title-sub u-pt0 u-ta-c">エラーが発生しました</p>
          {(isApolloNetworkError(error) && error.networkError.message.match(/401/) && (
            <div>
              認証が切れました。
              <br />
              ジョブカン労務HRまたはジョブカン給与計算からもう一度マイナンバーに入ってください。
            </div>
          )) ||
            (isApolloNetworkError(error) && error.networkError.message.match(/404/) && (
              <div>
                ページを表示できません
                <br />
                アクセスしようとしたページはアクセス権限がないか、削除・変更された可能性があります。
                <br />
                <a href="/" className="u-txt-link">
                  TOPへ
                </a>
              </div>
            )) || (
              <>
                <pre>{message}</pre>
                <pre>{process.env.NODE_ENV !== 'production' && stack}</pre>
                <div className="u-ta-c u-mt20">
                  <a
                    role="link"
                    tabIndex={0}
                    onClick={() => {
                      window.location.reload();
                    }}
                    onKeyPress={() => {
                      window.location.reload();
                    }}
                    className="u-txt-link">
                    ページリロード
                  </a>
                </div>
              </>
            )}
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
